import { userService } from '../services/user.service';
import { useApi } from './use-api';

export function useUser(userId: string | undefined) {
  const { loading, result: user, error } = useApi(userService.get, userId);
  return { loading, user, error };
}
